import { LoanCriteria } from '@nemuru-eng/js-api-client';

import { StepStats } from '../types/StepStats';

export const combineStats = (statsList: StepStats[]) => {
  const combinedStats = {
    loans: [] as LoanCriteria[],
    totalAmount: 0,
    alerts: 0,
  };
  statsList.forEach((stat) => {
    combinedStats.loans.push(...stat.loans);
    combinedStats.totalAmount += stat.totalAmount;
    combinedStats.alerts += stat.errors;
  });
  return combinedStats;
};
